import { render, staticRenderFns } from "./AppointVehicleAdd.vue?vue&type=template&id=e4a52dd6&scoped=true&"
import script from "./AppointVehicleAdd.vue?vue&type=script&lang=js&"
export * from "./AppointVehicleAdd.vue?vue&type=script&lang=js&"
import style0 from "./AppointVehicleAdd.vue?vue&type=style&index=0&id=e4a52dd6&lang=less&scoped=true&"
import style1 from "./AppointVehicleAdd.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a52dd6",
  null
  
)

export default component.exports